import I18n from 'i18n-js'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import AutocompletionWithoutListing from './AutocompletionWithoutListing'

const CustomList = ({ type, items = [], handleChange, editMode = false, selectables = [], toShow, deactivated = false }) => {
  // Assurer des valeurs par défaut pour éviter les erreurs
  const safeItems = Array.isArray(items) ? items : []
  const safeSelectables = Array.isArray(selectables) ? selectables : []

  const handleItemChange = (updatedItems) => {
    handleChange(type, updatedItems)
  }

  const removeItem = (itemToRemove) => {
    handleItemChange(safeItems.filter((item) => item !== itemToRemove))
  }

  const addItem = (itemToAdd) => {
    // Vérifier si l'élément existe déjà
    if (safeItems.some((item) => item.id === itemToAdd.id)) {
      return
    }

    handleItemChange([...safeItems, itemToAdd])
  }

  const renderItem = (item) => {
    const displayText = toShow !== 'fullname' ? item[toShow] : `${item.firstname} ${item.lastname}`

    return editMode ? (
      <div key={item.id} className="configuration container d-flex justify-content-between align-items-center">
        <span className="category-subtitle">{displayText}</span>
        <div className="d-flex">
          <div className="action-button small" onClick={() => removeItem(item)}>
            <FontAwesome name="trash" />
          </div>
        </div>
      </div>
    ) : (
      <div key={item.id} className="category-subtitle">
        {displayText}
      </div>
    )
  }

  const alreadySelectedItemsId = safeItems.map((item) => item.id)
  const addableItems = safeSelectables.filter((item) => !alreadySelectedItemsId.includes(item.id))

  return (
    <div>
      {safeItems.length > 0 ? (
        safeItems.map((item) => renderItem(item))
      ) : (
        <p style={{ color: deactivated ? '' : type === 'agencies' ? 'blue' : 'red' }}>{I18n.t('UserConfigurationNo' + type)}</p>
      )}

      {editMode && !deactivated && (
        <AutocompletionWithoutListing suggestions={addableItems} toShow={toShow} onSelect={addItem} keepSelection={false} />
      )}
    </div>
  )
}

export default CustomList
